import { get } from 'lodash';
import { ACTIONS } from '../Constants';
import AuthService from '../utils/AuthService';
import { userPermissionsByRole } from '../utils/permissionHelperUtils';

const getNewAuthState = () => ({
    isAuthenticated: AuthService.isLoggedIn(),
    isVerbAdmin: false,
    isAccountOwner: false,
    isContentAuthor: false,
    isContentAdmin: false,
    isReportViewer: false,
    isContentReviewer: false,
    isTeamAdmin: false,
    isTeamReportViewer: false,
    isCompanyReportViewer: false,
    isVerbReportViewer: false,
    isInstructionalAdmin: false,
    isInstructionalContentAdmin: false,
    isInstructionalReportViewer: false,
    isFetching: false,
    loggedInUser: {},
    loggedInUserId: '',
    idToken: AuthService.getToken(),
    loggedInUserCompanyId: AuthService.getUserCompany(),
    companyPermalink: AuthService.getUserCompanyPermalink(),
    loggedInUserLanguage: AuthService.getUserLanguage() || '',
    error: null
});

const authReducer = (state = getNewAuthState(), action) => {
    switch (action.type) {
        case ACTIONS.LOGIN_REQUEST:
            return {
                ...state,
                isFetching: true,
                error: null
            };
        case ACTIONS.LOGIN_SUCCESS: {
            const permissionRoles = get(action, 'payload.userProfile.permissionRoles', []);
            const {
                isContentReviewer,
                isContentAuthor,
                isContentAdmin,
                isTeamAdmin,
                isAccountOwner,
                isVerbAdmin,
                isTeamReportViewer,
                isCompanyReportViewer,
                isVerbReportViewer,
                isInstructionalAdmin,
                isInstructionalContentAdmin,
                isInstructionalReportViewer
            } = userPermissionsByRole(permissionRoles);
            return {
                ...state,
                isAuthenticated: true,
                isContentReviewer,
                isContentAuthor,
                isContentAdmin,
                isTeamAdmin,
                isAccountOwner,
                isVerbAdmin,
                isTeamReportViewer,
                isCompanyReportViewer,
                isVerbReportViewer,
                isInstructionalAdmin,
                isInstructionalContentAdmin,
                isInstructionalReportViewer,
                isFetching: false,
                loggedInUser: action.payload.userProfile,
                loggedInUserId: action.payload.userProfile._id,
                loggedInUserCompanyId: action.payload.userProfile.companyId,
                companyPermalink: action.payload.userProfile.companyPermalink,
                idToken: action.payload.idToken,
                loggedInUserLanguage: action.payload.userProfile.language,
                error: null,
                source: action.payload.source
            };
        }
        case ACTIONS.LOGIN_RENEW_TOKEN:
            return {
                ...state,
                idToken: action.payload.idToken
            };

        case ACTIONS.UPDATE_PROFILE:
        case ACTIONS.GET_PROFILE:
            if (action.payload && action.payload.isLoggedInUser) {
                const permissionRoles = get(action, 'payload.profile.permissionRoles', []);
                const {
                    isContentReviewer,
                    isContentAuthor,
                    isContentAdmin,
                    isTeamAdmin,
                    isAccountOwner,
                    isVerbAdmin,
                    isTeamReportViewer,
                    isCompanyReportViewer,
                    isVerbReportViewer,
                    isInstructionalAdmin,
                    isInstructionalContentAdmin,
                    isInstructionalReportViewer
                } = userPermissionsByRole(permissionRoles);

                return {
                    ...state,
                    loggedInUser: action.payload.profile,
                    isContentReviewer,
                    isContentAuthor,
                    isContentAdmin,
                    isTeamAdmin,
                    isAccountOwner,
                    isVerbAdmin,
                    isTeamReportViewer,
                    isCompanyReportViewer,
                    isVerbReportViewer,
                    isInstructionalAdmin,
                    isInstructionalContentAdmin,
                    isInstructionalReportViewer,
                    loggedInUserLanguage: action.payload.profile.language || ''
                };
            }
            return state;
        case ACTIONS.UPDATE_LOGGED_IN_USER: {
            const { badges } = action.payload;
            const loggedInUserCopy = state.loggedInUser;
            loggedInUserCopy.badges = (loggedInUserCopy.badges || []).concat(badges);

            return {
                ...state
            };
        }
        case ACTIONS.PUT_PROFILE_COLLECTION:
            return {
                ...state,
                loggedInUser: action.payload.profile
            };
        case ACTIONS.LOGIN_ERROR:
            return {
                ...state,
                isAuthenticated: false,
                isVerbAdmin: false,
                isAccountOwner: false,
                isContentAuthor: false,
                isCompanyReportViewer: false,
                isContentAdmin: false,
                isInstructionalAdmin: false,
                isInstructionalContentAdmin: false,
                isInstructionalReportViewer: false,
                companyPermalink: '',
                isFetching: false,
                loggedInUser: {},
                loggedInUserId: null,
                idToken: null,
                loggedInUserLanguage: '',
                error: action.error
            };
        case ACTIONS.LOGOUT:
            return {
                ...state,
                isAuthenticated: false,
                isVerbAdmin: false,
                isAccountOwner: false,
                isContentAuthor: false,
                isCompanyReportViewer: false,
                isContentAdmin: false,
                isInstructionalAdmin: false,
                isInstructionalContentAdmin: false,
                isInstructionalReportViewer: false,
                companyPermalink: '',
                isFetching: false,
                loggedInUser: {},
                loggedInUserId: null,
                idToken: null,
                loggedInUserLanguage: '',
                error: null
            };
        case ACTIONS.CLEAR_SOURCE:
            return {
                ...state,
                source: {}
            };
        case ACTIONS.AUTHENTICATE_ONLY:
            return {
                ...state,
                isAuthenticated: true
            };
        default:
            return state;
    }
};

export default authReducer;
